import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl + '/api/ecas_participantes';
const baseUrl2 = config.baseUrl + '/api/asignar-participantes';

export const getAllEcas = async () => {
  const response = await axios.get(`${baseUrl}`);
  return response.data;
};

export const getAllEcasParticipantes = async () => {
  const response = await axios.get(`${baseUrl}/registrados`);
  return response.data;
};

export const getEcaById = async (id) => {
  const response = await axios.get(`${baseUrl}/${id}`);
  return response.data;
};

export const createEca = async (data) => {
  const response = await axios.post(`${baseUrl}`, data);
  return response.data;
};

export const updateEca = async (id, data) => {
  const response = await axios.put(`${baseUrl}/${id}`, data);
  return response.data;
};

export const deleteEca = async (id, userdelete) => {
  const response = await axios.delete(`${baseUrl}/${id}`, {
    data: { userdelete },
  });
  return response.data;
};

export const getParticipantes = async () => {
  const response = await axios.get(`${baseUrl}/participantes`);
  return response.data;
};

export const getParticipantesAgregados = async (eca_oid) => {
  const response = await axios.get(`${baseUrl}/asignados/${eca_oid}`);
  return response.data;
};

export const getParticipantesNoAgregados = async (eca_oid) => {
  const response = await axios.get(`${baseUrl}/no-asignados/${eca_oid}`);
  return response.data;
};

export const getDepartamentos = async () => {
  const res = await axios.get(`${baseUrl}/departamentos`);
  return res.data;
};

export const getMunicipios = async () => {
  const res = await axios.get(`${baseUrl}/municipios`);
  return res.data;
};

export const getSesionEcas = async () => {
  const res = await axios.get(`${baseUrl}/sesiones-ecas-nombre/`);
  return res.data;
};

export const assignParticipants = async (eca_oid, participantes) => {
  const response = await axios.post(baseUrl2, {
    eca_oid,
    participantes,
  });
  return response.data;
};

export const quitarParticipante = async (eca_oid, participante_oid) => {
  const response = await axios.delete(`${baseUrl}/quitar/${eca_oid}/${participante_oid}`);
  return response.data;
};


export const getParticipantesFiltrados = async ({ departamentoId, municipioId, search, eca_oid }) => {
  const params = new URLSearchParams();

  if (departamentoId) params.append("departamentoId", departamentoId);
  if (municipioId) params.append("municipioId", municipioId);
  if (search) params.append("search", search);
  if (eca_oid) params.append("eca_oid", eca_oid);

  const response = await axios.get(`${baseUrl}/participantes-filtrados?${params.toString()}`);
  return response.data;
};
